﻿import {FormControl, Grid, Select} from "@mui/material";
import styled from "@mui/system/styled";

export const SearchFilterDropDown = styled(Select<string[]>)(({theme}) => ({
  width: '18em',
  [theme.breakpoints.down('lg')]: {
    width: '20em',
  },
  [theme.breakpoints.down('sm')]: {
    width: "100%",
  },
  '& .MuiChip-filledDefault .MuiChip-labelSmall': {
    fontSize: '0.8em !important',
    padding: '0em 0.4em !important'
  },
}));

export const SearchFilterContainer = styled(Grid)(({theme}) => ({
  padding: '1em 1.5em',
  [theme.breakpoints.down('sm')]: {
    padding: '0.75em 1.5em',
  },
  justifyContent: 'space-between',
  '& .css-1pggc45-MuiFormLabel-root-MuiInputLabel-root': {
    fontSize: '0.9em !important',
    left: '-0.7em'
  },
  '& .css-1ax3epa-MuiFormLabel-root-MuiInputLabel-root': {
    fontSize: '1em !important',
    left: '-0.7em'
  },
}));

export const SearchFilterGridChild = styled(Grid)(({theme}) => ({
  [theme.breakpoints.down('sm')]: {
    width: "100%",
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const SearchFilterFormControl = styled(FormControl)(() => ({
  width: "inherit",
}));

export const SearchFilterSearchChipMultiSelectRenderDiv = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'nowrap',
  overflow: 'auto',
  whiteSpace: 'nowrap',
  columnGap: '2px'
}));
